import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/components/views/Home.vue'
const name_shop = window.__STORE_INFO__?.name || "فروشگاه"
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: name_shop }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/components/views/Products.vue'),
    meta: { title: 'محصولات' }
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: () => import('@/components/views/PaymentResult.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/components/views/Blog.vue'),
    meta: { title: 'بلاگ' }
  },
  {
    path: '/category/:slug',
    name: 'CategoryProducts',
    component: () => import('@/components/views/CategoryProducts.vue'),
    meta: { title: 'دسته‌بندی محصولات' }
  },
  {
    path: '/Campaign',
    name: 'Campaign',
    component: () => import('@/components/views/CampaignDetail.vue'),
    meta: { title: 'کمپین' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/views/Auth.vue'),
    meta: { title: 'ورود' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/components/views/register.vue'),
    meta: { title: 'ثبت نام' }
  },
  {
    path: '/blog/:slug',
    name: 'BlogDetail',
    component: () => import('@/components/views/BlogDetail.vue'),
    meta: { title: 'جزئیات مقاله' }
  },
  {
    path: '/Products/:slug',
    // لینک‌هایی که فیدهای ایمالز/ترب و نقشه سایت می‌سازند: /product/<slug>/
    alias: '/product/:slug',
    name: 'Product',
    component: () => import('@/components/views/ProductDetail.vue'),
    meta: { title: 'جزئیات محصول' }
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('@/components/views/AboutUs.vue'),
    meta: { title: 'درباره ما' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/components/views/Contact.vue'),
    meta: { title: 'تماس با ما' }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/components/views/faq.vue'),
    meta: { title: 'سوالات متداول' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/components/views/profile.vue'),
    meta: { title: 'پروفایل کاربری' }
  },
  {
    path: '/Cart',
    name: 'Cart',
    component: () => import('@/components/views/Cart.vue'),
    meta: { title: 'سبد خرید' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/components/views/NotFound.vue'),
    meta: { title: 'صفحه پیدا نشد' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  }
})

/* ✅ تغییر خودکار title */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `${to.meta.title} | نام سایت شما`
    : 'نام سایت شما'
  next()
})

export default router
